<template>
  <div class="wholeContext">
    <app-sidebar></app-sidebar>
    <app-header :transDataSet="transDate"></app-header>
    <div class="appContext withTab">
      <div class="container">
        <div class="area_wrap">
          <div class="tab_header refer">
            <ul class="th_body tabs">
              <li class="th_content" v-for="tab in tabs" :key="tab.tabName" :class="{active: tab === selectedTab}" @click="onClickTab(tab)">
                <p>{{tab.tabName}}</p>
              </li>
            </ul>
            <div v-if="selectedTab === tabs[0]">
              <div class="trackingProgress">
                <div class="progress"></div>
              </div>
              <div class="center_text mb-0">
                <p>*환자의 배우자, 직계존비속, 배우자의 직계존속이
                  발급 신청 시 필요한 서류입니다.</p>
              </div>
              <div class="step_wrap">
                <div class="sw_item">
                  <div class="item_number red">
                    <p>01</p>
                  </div>
                  <div class="item_content">
                    <p>신청자의 신분증 또는 신분증사본</p>
                    <span>(주민등록증, 운전면허증, 여권 등)</span>
                  </div>
                </div>
                <div class="sw_item">
                  <div class="item_number black">
                    <p>02</p>
                  </div>
                  <div class="item_content">
                    <p>가족관계증명서, 주민등록표등본 등</p>
                    <p>직계가족임을 확인할 수 있는 서류</p>
                  </div>
                </div>
                <div class="sw_item">
                  <div class="item_number red">
                    <p>03</p>
                  </div>
                  <div class="item_content">
                    <p>보건복지가족부에서 배포한 별지 9-2의</p>
                    <p>환자가 자필로 서명한 동의서</p>
                    <span>(단, 만 14세 미만의 미성년자인 경우 제외)</span>
                  </div>
                </div>
                <div class="sw_item">
                  <div class="item_number black">
                    <p>04</p>
                  </div>
                  <div class="item_content">
                    <p>환자 본인의 신분증 사본</p>
                    <span>(단, 환자가 만 17세 미만으로 주민등록증 발급이 안 된 경우 제외)</span>
                  </div>
                </div>
              </div>
              <div class="center_text pt-0 mb-0">
                <p>※ 형제자매, 사위, 며느리는 직계가족의 범위에 들어가지 않습니다. 이점 유의하시기 바랍니다.</p>
              </div>
            </div>
            <div v-else>
              <div class="trackingProgress">
                <div class="progress reverse"></div>
              </div>
              <div class="center_text mb-0">
                <p>*환자가 지정하는 대리인이 발급 신청 시 </p>
                <p>필요한 서류입니다.</p>
              </div>
              <div class="step_wrap">
                <div class="sw_item">
                  <div class="item_number red">
                    <p>01</p>
                  </div>
                  <div class="item_content">
                    <p>신청자의 신분증 또는 신분증 사본</p>
                    <span>(주민등록증, 운전면허증, 여권 등)</span>
                  </div>
                </div>
                <div class="sw_item">
                  <div class="item_number black">
                    <p>02</p>
                  </div>
                  <div class="item_content">
                    <p>보건복지가족부에서 배포한 별지 9-2, 9-3의 </p>
                    <p>환자가 자필로 서명한 동의서와 위임장</p>
                    <span>단, 환자가 만 14세 미만의 미성년자인 경우 환자의 부모가 </span>
                    <span>작성 후 가족관계증명서나 주민등록표등본 첨부)</span>
                  </div>
                </div>
                <div class="sw_item">
                  <div class="item_number red">
                    <p>03</p>
                  </div>
                  <div class="item_content">
                    <p>환자 본인의 신분증 사본</p>
                    <span>(단, 환자가 만 17세 미만으로 주민등록증 발급 안 된 경우 제외, </span>
                    <span>환자가 만 14세미만으로 동의서, 위임장을 부모가 작성했을 경우</span>
                    <span>부모의 신분증 사본 첨부)</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="btnWrap visible">
        <router-link to="/">
          <button type="button" class="callTerms">메인페이지</button>
        </router-link>
      </div>
    </div>
    <add-popup v-if="checkPopup"
               :popupSet="popupSet"/>
  </div>
</template>

<script>
import AppHeader from '@/components/AppHeader'
import AppSidebar from '@/components/AppSidebar'
import AddPopup from '@/components/AddPopup'
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'
export default {
  data () {
    return {
      popupSet: {
        title: '',
        modalImg: 'alert_cn.svg',
        content: '',
        confirmBtnText: '확인',
        count: 'single'
      },
      transDate: {
        headerName: '제증명 발급 신청하기',
        prevUrl: '/certificateLookupList'
      },
      selectedTab: '',
      tabs: [
        { tabName: '배우자, 직계손비속, 배우자의 직계존속' },
        { tabName: '환자가 지정한 대리인' }
      ]
    }
  },
  computed: {
    ...mapGetters([

    ]),
    ...mapState([
      'checkPopup'
    ])
  },
  methods: {
    ...mapMutations([
      'SET_POPUP'
    ]),
    ...mapActions([

    ]),
    onClickTab (tab) {
      this.selectedTab = tab
    }
  },
  components: {
    AppHeader,
    AppSidebar,
    AddPopup
  },
  created () {
    this.selectedTab = this.tabs[0]
  }
}
</script>

<style lang="scss" scoped>
</style>
